// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".tabs-container.md-ripple{background-color:#fff}.md-button-content{display:flex;align-items:center}", "",{"version":3,"sources":["/builds/hydra/intern/feedback-tool-www/src/pages/issue-list.vue"],"names":[],"mappings":"AACA,0BACE,qBAAA,CAEF,mBACE,YAAA,CACA,kBAAA","file":"issue-list.vue","sourcesContent":["\n.tabs-container.md-ripple {\n  background-color: #fff;\n}\n.md-button-content {\n  display: flex;\n  align-items: center;\n}\n"]}]);
// Exports
module.exports = exports;
